import { SelectOption } from '@app/shared/models/multiselect-options.model';
import { createReducer, on } from '@ngrx/store';
import { voivodeshipListActions } from '../actions/voivodeship-list.actions';

export interface VoivodeshipState {
    voivodeship: SelectOption[] | null;
    loaded: boolean | null;
    loading: boolean | null;
}

export const initialState: VoivodeshipState = {
    voivodeship: null,
    loaded: null,
    loading: null,
};

export const voivodeshipReducer = createReducer(
    initialState,
    on(
        voivodeshipListActions.getVoivodeshipList,
        (state): VoivodeshipState => ({
            ...state,
            loading: true,
            loaded: null,
        }),
    ),
    on(
        voivodeshipListActions.getVoivodeshipListSuccess,
        (state, { payload }): VoivodeshipState => ({
            ...state,
            voivodeship: payload,
            loading: false,
            loaded: true,
        }),
    ),
    on(
        voivodeshipListActions.getVoivodeshipListError,
        (state): VoivodeshipState => ({
            ...state,
            loading: false,
            loaded: false,
        }),
    ),
    on(voivodeshipListActions.clear, (): VoivodeshipState => initialState),
);
